import React, { useState, useEffect } from 'react';
import { getPartners, createPartner, getCycles, createCycle, getSessions, createSession } from '../api/api';
import API from '../api/api';
import Bills from './Bills';
import ControlPanel from './ControlPanel';
import GeneralRevenues from './GeneralRevenues';
import WhatsApp from './WhatsApp';
import Summary from './Summary';
import Expenses from './Expenses';
import Revenues from './Revenues';

function PartnershipDetail({ partnership, onBack, onReports, onSchedule }) {
  const [tab, setTab] = useState(() => sessionStorage.getItem('currentTab') || 'partners');
  useEffect(() => {
    const handler = (e) => { setTab(e.detail); sessionStorage.setItem('currentTab', e.detail); };
    window.addEventListener('switchTab', handler);
    return () => window.removeEventListener('switchTab', handler);
  }, []);
  const [partners, setPartners] = useState([]);
  const [cycles, setCycles] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [selectedCycle, setSelectedCycle] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [partnerForm, setPartnerForm] = useState({ name:'', phone:'', order:1, quota_days:'', quota_hours:'', quota_kilowatts:'', role:'partner' });
  const [cycleForm, setCycleForm] = useState({ cycle_number:'', start_date:'' });
  const [sessionForm, setSessionForm] = useState({ partner:'', date:'', run_type:'full', fajr_time:'', maghrib_time:'', hours_actual:'', kilowatts_actual:'', no_operation:false, no_operation_reason:'', notes:'' });

  const qt = partnership.quota_type;

  useEffect(() => {
    getPartners(partnership.id).then(r => setPartners(r.data));
    getCycles(partnership.id).then(r => { setCycles(r.data); if(r.data.length > 0) setSelectedCycle(r.data[r.data.length-1]); });
  }, [partnership.id]);

  useEffect(() => {
    if (selectedCycle) getSessions(selectedCycle.id).then(r => setSessions(r.data));
  }, [selectedCycle]);

  const savePartner = async (e) => {
    e.preventDefault();
    const data = { ...partnerForm, partnership: partnership.id };
    if (editItem) {
      const res = await API.put(`/partners/${editItem.id}/`, data);
      setPartners(partners.map(p => p.id === editItem.id ? res.data : p));
    } else {
      const res = await createPartner(data);
      setPartners([...partners, res.data]);
    }
    setShowForm(false); setEditItem(null);
    setPartnerForm({ name:'', phone:'', order:1, quota_days:'', quota_hours:'', quota_kilowatts:'', role:'partner' });
  };

  const deletePartner = async (id, name) => {
    if (!window.confirm(`حذف "${name}"؟`)) return;
    await API.delete(`/partners/${id}/`);
    setPartners(partners.filter(p => p.id !== id));
  };

  const editPartner = (p) => {
    setEditItem(p);
    setPartnerForm({ name:p.name, phone:p.phone||'', order:p.order, quota_days:p.quota_days||'', quota_hours:p.quota_hours||'', quota_kilowatts:p.quota_kilowatts||'', role:p.role });
    setShowForm(true);
  };

  const saveCycle = async (e) => {
    e.preventDefault();
    const data = { ...cycleForm, partnership: partnership.id, is_current: true };
    const res = await createCycle(data);
    setCycles([...cycles, res.data]);
    setSelectedCycle(res.data);
    setShowForm(false);
  };

  const saveSession = async (e) => {
    e.preventDefault();
    const data = { ...sessionForm, cycle: selectedCycle.id };
    const res = await createSession(data);
    setSessions([...sessions, res.data]);
    setShowForm(false);
    setSessionForm({ partner:'', date:'', run_type:'full', fajr_time:'', maghrib_time:'', hours_actual:'', kilowatts_actual:'', no_operation:false, no_operation_reason:'', notes:'' });
  };

  const deleteSession = async (id) => {
    if (!window.confirm('حذف هذه الجلسة؟')) return;
    await API.delete(`/sessions/${id}/`);
    setSessions(sessions.filter(s => s.id !== id));
  };

  const runTypeLabel = { full:'يوم كامل', half:'نصف يوم', quarter:'ربع يوم', hours:'ساعات', half_hour:'نصف ساعة', kilowatts:'كيلوواط' };
  const tabStyle = (t) => ({ padding:'10px 18px', border:'none', cursor:'pointer', borderBottom: tab===t ? '3px solid #1e3a5f' : '3px solid transparent', background:'transparent', fontWeight:'bold', color: tab===t ? '#1e3a5f' : '#555', fontSize:'15px', whiteSpace:'nowrap', flexShrink:0 });
  const btnStyle = (color, size) => ({ padding: size==='sm' ? '5px 10px' : '8px 16px', background:color, color:'white', border:'none', borderRadius:'6px', cursor:'pointer', fontSize: size==='sm' ? '12px' : '13px' });

  return (
    <div style={{ padding:'20px' }}>
      <div style={{ display:'flex', alignItems:'center', gap:'15px', marginBottom:'20px' }}>
        <button onClick={onBack} style={{ padding:'8px 15px', background:'#6c757d', color:'white', border:'none', borderRadius:'6px', cursor:'pointer' }}>← رجوع</button>
        {(()=>{ const u=JSON.parse(localStorage.getItem('user')||'null'); return !u||u.role==='admin'||(u.permissions||[]).includes('reports'); })() && <button onClick={onReports} style={{ padding:'8px 15px', background:'#27ae60', color:'white', border:'none', borderRadius:'6px', cursor:'pointer' }}>📊 التقارير</button>}
        {(()=>{ const u=JSON.parse(localStorage.getItem('user')||'null'); return !u||u.role==='admin'||(u.permissions||[]).includes('schedule'); })() && <button onClick={onSchedule} style={{ padding:'8px 15px', background:'#1e3a5f', color:'white', border:'none', borderRadius:'6px', cursor:'pointer' }}>📅 جدول التشغيل</button>}
        <h2 style={{ color:'#1e3a5f', margin:0 }}>💧 {partnership.name}</h2>
        <span style={{ color:'#666', fontSize:'13px' }}>| دورة {partnership.cycle_days} يوم | {qt==='days'?'أيام':qt==='hours'?'ساعات':'كيلوواط'}</span>
      </div>

      <div style={{ display:'flex', borderBottom:'1px solid #ddd', marginBottom:'20px', overflowX:'auto', WebkitOverflowScrolling:'touch', scrollbarWidth:'thin', scrollbarColor:'#1e3a5f #f0f0f0' }}>
        {(() => {
          const u = JSON.parse(localStorage.getItem('user')||'null');
          const isAdmin = !u || u.role === 'admin';
          const perms = u ? (u.permissions || []) : [];
          const tabPermMap = {
            'partners': 'partners', 'bills': 'bills', 'expenses': 'expenses',
            'revenues': 'revenues', 'general_revenues': 'general_revenue',
            'whatsapp': 'whatsapp', 'summary': 'summary',
            'control': ['cp_info','cp_partners','cp_cycles','cp_sessions','cp_fees','cp_whatsapp','cp_lists','cp_slots','cp_security','cp_backup','cp_delete']
          };
          const cpPerms = ['cp_info','cp_partners','cp_cycles','cp_sessions','cp_fees','cp_whatsapp','cp_lists','cp_slots','cp_security','cp_backup','cp_users'];
          const hasControlAccess = isAdmin || cpPerms.some(p=>perms.includes(p));
          return ['partners','bills','expenses','revenues','general_revenues','whatsapp','summary','control'].filter(t => {
            if(isAdmin) return true;
            if(t === 'partners') return isAdmin || perms.includes('partners') || u.role==='manager';
            if(t === 'control') return hasControlAccess;
            const perm = tabPermMap[t];
            return perm && perms.includes(perm);
          });
        })().map(t => (
          <button key={t} style={tabStyle(t)} onClick={() => { setTab(t); sessionStorage.setItem('currentTab', t); setShowForm(false); setEditItem(null); }}>
            {t==='partners'?'👥 الشركاء':t==='cycles'?'🔄 الدورات':t==='sessions'?'⚡ جلسات التشغيل':t==='bills'?'⚡ فواتير الكهرباء':t==='expenses'?'🧾 المصروفات':t==='revenues'?'💰 الإيرادات':t==='general_revenues'?'💰 الإيراد العام':t==='summary'?'📊 ملخص الحسابات':t==='control'?'⚙️ لوحة التحكم':<span style={{background:'#25D366',color:'white',padding:'4px 12px',borderRadius:'8px',fontWeight:'bold',fontSize:'16px'}}>💬</span>}
          </button>
        ))}
      </div>

      {tab === 'partners' && (
        <div>
          <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'15px' }}>
            <h3>الشركاء ({partners.length})</h3>
            {(()=>{ const u=JSON.parse(localStorage.getItem('user')||'null'); return !u||u.role==='admin'||(u.permissions||[]).includes('partners'); })() && <button onClick={() => { setShowForm(!showForm); setEditItem(null); setPartnerForm({ name:'', phone:'', order:partners.length+1, quota_days:'', quota_hours:'', quota_kilowatts:'', role:'partner' }); }} style={btnStyle('#1e3a5f')}>+ إضافة شريك</button>}
          </div>
          {showForm && (
            <form onSubmit={savePartner} style={{ background:'white', padding:'20px', borderRadius:'10px', marginBottom:'15px', boxShadow:'0 2px 8px rgba(0,0,0,0.1)' }}>
              <h4 style={{ marginBottom:'12px' }}>{editItem ? 'تعديل شريك' : 'شريك جديد'}</h4>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'12px' }}>
                <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>الاسم *</label>
                  <input value={partnerForm.name} onChange={e => setPartnerForm({...partnerForm, name:e.target.value})} required style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>
                <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>الجوال</label>
                  <input value={partnerForm.phone} onChange={e => setPartnerForm({...partnerForm, phone:e.target.value})} style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>
                <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>الترتيب *</label>
                  <input type="number" value={partnerForm.order} onChange={e => setPartnerForm({...partnerForm, order:e.target.value})} required style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>
                {qt==='days' && <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>النصاب (أيام)</label>
                  <input type="number" step="0.5" value={partnerForm.quota_days} onChange={e => setPartnerForm({...partnerForm, quota_days:e.target.value})} style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>}
                {qt==='hours' && <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>النصاب (ساعات)</label>
                  <input type="number" step="0.5" value={partnerForm.quota_hours} onChange={e => setPartnerForm({...partnerForm, quota_hours:e.target.value})} style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>}
                {qt==='kilowatts' && <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>النصاب (كيلوواط)</label>
                  <input type="number" step="0.1" value={partnerForm.quota_kilowatts} onChange={e => setPartnerForm({...partnerForm, quota_kilowatts:e.target.value})} style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>}
              </div>
              <div style={{ marginTop:'12px', display:'flex', gap:'10px' }}>
                <button type="submit" style={btnStyle('#27ae60')}>حفظ</button>
                <button type="button" onClick={() => { setShowForm(false); setEditItem(null); }} style={btnStyle('#e74c3c')}>إلغاء</button>
              </div>
            </form>
          )}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(220px, 1fr))', gap:'12px' }}>
            {partners.map(p => (
              <div key={p.id} style={{ background:'white', padding:'15px', borderRadius:'8px', boxShadow:'0 2px 8px rgba(0,0,0,0.08)', borderRight:'3px solid #3498db' }}>
                <h4 style={{ margin:'0 0 8px', color:'#1e3a5f' }}>#{p.order} {p.name}</h4>
                <p style={{ margin:'3px 0', color:'#666', fontSize:'13px' }}>📱 {p.phone || 'غير محدد'}</p>
                <p style={{ margin:'3px 0', color:'#27ae60', fontSize:'13px', fontWeight:'bold' }}>
                  النصاب: {p.quota} {qt==='days'?'يوم':qt==='hours'?'ساعة':'كيلوواط'}
                </p>
                <div style={{ marginTop:'10px', display:'flex', gap:'6px' }}>
                  <button onClick={() => editPartner(p)} style={btnStyle('#f39c12','sm')}>✏️ تعديل</button>

                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {tab === 'cycles' && (
        <div>
          <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'15px' }}>
            <h3>الدورات ({cycles.length})</h3>
            <button onClick={() => setShowForm(!showForm)} style={btnStyle('#1e3a5f')}>+ دورة جديدة</button>
          </div>
          {showForm && (
            <form onSubmit={saveCycle} style={{ background:'white', padding:'20px', borderRadius:'10px', marginBottom:'15px', boxShadow:'0 2px 8px rgba(0,0,0,0.1)' }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
                <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>رقم الدورة *</label>
                  <input type="number" value={cycleForm.cycle_number} onChange={e => setCycleForm({...cycleForm, cycle_number:e.target.value})} required style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>
                <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>تاريخ البداية *</label>
                  <input type="date" value={cycleForm.start_date} onChange={e => setCycleForm({...cycleForm, start_date:e.target.value})} required style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>
              </div>
              <div style={{ marginTop:'12px', display:'flex', gap:'10px' }}>
                <button type="submit" style={btnStyle('#27ae60')}>حفظ</button>
                <button type="button" onClick={() => setShowForm(false)} style={btnStyle('#e74c3c')}>إلغاء</button>
              </div>
            </form>
          )}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(220px, 1fr))', gap:'12px' }}>
            {cycles.map(c => (
              <div key={c.id} onClick={() => { setSelectedCycle(c); setTab('sessions'); sessionStorage.setItem('currentTab', 'sessions'); }}
                style={{ background: selectedCycle?.id===c.id ? '#e8f4fd':'white', padding:'15px', borderRadius:'8px', boxShadow:'0 2px 8px rgba(0,0,0,0.08)', cursor:'pointer', borderRight:`3px solid ${c.is_current?'#27ae60':'#aaa'}` }}>
                <h4 style={{ margin:'0 0 8px', color:'#1e3a5f' }}>دورة رقم {c.cycle_number}</h4>
                <p style={{ margin:'3px 0', color:'#666', fontSize:'13px' }}>📅 {c.start_date}</p>
                <span style={{ background:c.is_current?'#d4edda':'#f8d7da', color:c.is_current?'#155724':'#721c24', padding:'2px 8px', borderRadius:'12px', fontSize:'12px' }}>
                  {c.is_current?'الحالية':'منتهية'}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {tab === 'summary' && <Summary partnership={partnership} partners={partners} />}
      {tab === 'general_revenues' && <GeneralRevenues partnership={partnership} />}
      {tab === 'whatsapp' && <WhatsApp partnership={partnership} currentUser={JSON.parse(localStorage.getItem('user')||'null')} />}
      {tab === 'control' && <ControlPanel partnership={partnership} onRefresh={()=>{}} onDelete={()=>onBack()} />}
      {tab === 'bills' && <Bills partnership={partnership} />}
      {tab === 'expenses' && <Expenses partnership={partnership} partners={partners} />}
      {tab === 'revenues' && <Revenues partnership={partnership} partners={partners} />}
      {tab === 'sessions' && (
        <div>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'15px' }}>
            <h3>جلسات التشغيل {selectedCycle?`- دورة ${selectedCycle.cycle_number}`:''}</h3>
            <div style={{ display:'flex', gap:'10px' }}>
              <select value={selectedCycle?.id||''} onChange={e => setSelectedCycle(cycles.find(c=>c.id===parseInt(e.target.value)))}
                style={{ padding:'7px', border:'1px solid #ddd', borderRadius:'5px' }}>
                {cycles.map(c=><option key={c.id} value={c.id}>دورة {c.cycle_number}</option>)}
              </select>
              {selectedCycle && <button onClick={() => setShowForm(!showForm)} style={btnStyle('#1e3a5f')}>+ إضافة جلسة</button>}
            </div>
          </div>
          {showForm && selectedCycle && (
            <form onSubmit={saveSession} style={{ background:'white', padding:'20px', borderRadius:'10px', marginBottom:'15px', boxShadow:'0 2px 8px rgba(0,0,0,0.1)' }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'12px' }}>
                <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>الشريك *</label>
                  <select value={sessionForm.partner} onChange={e => setSessionForm({...sessionForm, partner:e.target.value})} required style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }}>
                    <option value="">اختر شريك</option>
                    {partners.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
                  </select></div>
                <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>التاريخ *</label>
                  <input type="date" value={sessionForm.date} onChange={e => setSessionForm({...sessionForm, date:e.target.value})} required style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>
                <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>نوع التشغيل *</label>
                  <select value={sessionForm.run_type} onChange={e => setSessionForm({...sessionForm, run_type:e.target.value})} style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }}>
                    <option value="full">يوم كامل</option>
                    <option value="half">نصف يوم</option>
                    <option value="quarter">ربع يوم</option>
                    <option value="hours">ساعات</option>
                    <option value="half_hour">نصف ساعة</option>
                    {qt==='kilowatts'&&<option value="kilowatts">كيلوواط</option>}
                  </select></div>
                <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>وقت الفجر</label>
                  <input type="time" value={sessionForm.fajr_time} onChange={e => setSessionForm({...sessionForm, fajr_time:e.target.value})} style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>
                <div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>وقت المغرب</label>
                  <input type="time" value={sessionForm.maghrib_time} onChange={e => setSessionForm({...sessionForm, maghrib_time:e.target.value})} style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>
                {sessionForm.run_type==='hours'&&<div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>الساعات الفعلية</label>
                  <input type="number" step="0.5" value={sessionForm.hours_actual} onChange={e => setSessionForm({...sessionForm, hours_actual:e.target.value})} style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>}
                {qt==='kilowatts'&&<div><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>الكيلوواط الفعلية</label>
                  <input type="number" step="0.1" value={sessionForm.kilowatts_actual} onChange={e => setSessionForm({...sessionForm, kilowatts_actual:e.target.value})} style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>}
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={{ display:'flex', alignItems:'center', gap:'8px', cursor:'pointer', marginBottom:'8px' }}>
                    <input type="checkbox" checked={sessionForm.no_operation} onChange={e => setSessionForm({...sessionForm, no_operation:e.target.checked})} />
                    <span style={{ fontWeight:'bold', fontSize:'13px' }}>لم يتم التشغيل</span>
                  </label>
                  {sessionForm.no_operation&&<input value={sessionForm.no_operation_reason} onChange={e => setSessionForm({...sessionForm, no_operation_reason:e.target.value})} placeholder="سبب عدم التشغيل" style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} />}
                </div>
                <div style={{ gridColumn:'1/-1' }}><label style={{ display:'block', marginBottom:'4px', fontWeight:'bold', fontSize:'13px' }}>ملاحظات</label>
                  <input value={sessionForm.notes} onChange={e => setSessionForm({...sessionForm, notes:e.target.value})} style={{ width:'100%', padding:'7px', border:'1px solid #ddd', borderRadius:'5px', boxSizing:'border-box' }} /></div>
              </div>
              <div style={{ marginTop:'12px', display:'flex', gap:'10px' }}>
                <button type="submit" style={btnStyle('#27ae60')}>حفظ</button>
                <button type="button" onClick={() => setShowForm(false)} style={btnStyle('#e74c3c')}>إلغاء</button>
              </div>
            </form>
          )}
          <div style={{ overflowX:'auto', maxHeight:'calc(100vh - 200px)', overflowY:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', background:'white', borderRadius:'8px', overflow:'hidden', boxShadow:'0 2px 8px rgba(0,0,0,0.08)' }}>
              <thead style={{position:'sticky',top:0,zIndex:10}}>
                <tr style={{ background:'#1e3a5f', color:'white' }}>
                  {['التاريخ','الشريك','نوع التشغيل','الفجر','المغرب','النصاب المستهلك','ملاحظات',''].map(h=>(
                    <th key={h} style={{ padding:'12px', textAlign:'right', fontSize:'13px' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sessions.map((s,i)=>(
                  <tr key={s.id} style={{ background:i%2===0?'white':'#f8f9fa', borderBottom:'1px solid #eee' }}>
                    <td style={{ padding:'10px 12px', fontSize:'13px' }}>{s.date}</td>
                    <td style={{ padding:'10px 12px', fontSize:'13px', fontWeight:'bold' }}>{s.partner_name}</td>
                    <td style={{ padding:'10px 12px' }}>
                      <span style={{ background:s.no_operation?'#f8d7da':'#d4edda', color:s.no_operation?'#721c24':'#155724', padding:'3px 8px', borderRadius:'12px', fontSize:'12px' }}>
                        {s.no_operation?'❌ '+s.no_operation_reason:'✅ '+runTypeLabel[s.run_type]}
                      </span>
                    </td>
                    <td style={{ padding:'10px 12px', fontSize:'13px' }}>{s.fajr_time||'-'}</td>
                    <td style={{ padding:'10px 12px', fontSize:'13px' }}>{s.maghrib_time||'-'}</td>
                    <td style={{ padding:'10px 12px', fontSize:'13px', color:'#1e3a5f', fontWeight:'bold' }}>{s.consumed_quota}</td>
                    <td style={{ padding:'10px 12px', fontSize:'13px', color:'#666' }}>{s.notes||'-'}</td>
                    <td style={{ padding:'10px 12px' }}>
                      <button onClick={() => deleteSession(s.id)} style={btnStyle('#e74c3c','sm')}>🗑️</button>
                    </td>
                  </tr>
                ))}
                {sessions.length===0&&(
                  <tr><td colSpan="8" style={{ textAlign:'center', padding:'30px', color:'#666' }}>لا توجد جلسات بعد</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default PartnershipDetail;
